export const calcBonus = (effectivePayment, hourPayment) => {
	const result = effectivePayment - hourPayment;

	return Math.max(result, 0);
};
